/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import Block from '../../../block/Block';
import Translatable from '../../../translatable/Translatable';
import IconButton from '../../../icon-button/IconButton';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import NavigationContext from '../../../navigation-context/NavigationContext';
import WFMastheadContext from '../context/WFMastheadContext';
import HamburgerIcon from '../icons/hamburger/HamburgerIcon';
import TriangleIcon from '../../../icons/triangle-icon/TriangleIcon';
import styles from './MenuButton.less';

var MenuButton = function MenuButton() {
  var _useContext = useContext(WFMastheadContext),
      menuType = _useContext.menuType,
      device = _useContext.device,
      menuOpen = _useContext.menuOpen,
      setMenuOpen = _useContext.setMenuOpen;

  var _useContext2 = useContext(NavigationContext),
      getContainer = _useContext2.getContainer;

  var links = getContainer('HAMBURGER_MENU'); // Open the menu (if it's closed). We delegate the close behavior
  // to the menu itself, which looks for "outside" click events.

  var onClick = function onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    !menuOpen && setMenuOpen(true);
  };

  var classNames = getClasses({
    styles: styles,
    classes: ['button']
  });
  var triangleClassNames = getClasses({
    styles: styles,
    classes: ['triangle', menuOpen && 'active']
  });
  return links && ('button' === menuType || device.isMobile()) ? /*#__PURE__*/React.createElement(Block, {
    className: classNames
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClick,
    "aria-expanded": menuOpen
  }, /*#__PURE__*/React.createElement(Translatable, {
    className: "visuallyHidden",
    id: "global.navigation.menu"
  }), /*#__PURE__*/React.createElement(HamburgerIcon, null)), /*#__PURE__*/React.createElement(TriangleIcon, {
    width: "15px",
    height: "7px",
    className: triangleClassNames
  })) : null;
};

export default MenuButton;